var Actions;
(function (Actions) {
    Actions["GET_SUMMARY_REPORT"] = "getSummaryReportAction";
    Actions["GET_SCHEMA_REPORT"] = "getSchemaReportAction";
    Actions["GET_TEST_PLACE_SUMMARIES_REPORT"] = "getTestPlaceSummaryReportAction";
    Actions["GET_TEST_PLACE_PARTICIPANT_REPORT"] = "getTestPlaceSummaryParticipantReportAction";
    Actions["GET_SCHEMA_SUMMARIES_ASESOR_REPORT"] = "getSchemaSummariesAsesorReportAction";
    Actions["GET_SCHEMA_DETAIL_ASESOR_REPORT"] = "getSchemaDetailAsesorReportAction";
    Actions["GET_RESULT_SUMMARIES_REPORT"] = "getResultSummariesReportAction";
    Actions["GET_RESULT_DETAIL_REPORT"] = "getResultDetailReportAction";
    Actions["EXPORT_RESULT_DETAIL_REPORT"] = "exportResultDetailReportAction";
    Actions["DOWNLOAD_RESULT_DETAIL_REPORT"] = "downloadResultDetailReportAction";
    Actions["GET_ASSESSMENT_SCHEMA"] = "getAssessmentSchemaAction";
    Actions["GET_ASSESSMENT_TEST_PLACE"] = "getAssessmentTestPlaceAction";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_SUMMARY_REPORT"] = "setSummaryReportMutation";
    Mutations["SET_SCHEMA_REPORT"] = "setSchemaReportMutation";
    Mutations["SET_TEST_PLACE_SUMMARIES_REPORT"] = "setTestPlaceSummariesReportMutation";
    Mutations["SET_TEST_PLACE_PARTICIPANT_REPORT"] = "setTestPlaceParticipantReportMutation";
    Mutations["RESET_TEST_PLACE_PARTICIPANT_REPORT"] = "resetTestPlaceParticipantReportMutation";
    Mutations["SET_SCHEMA_DETAILS_ASESOR_REPORT"] = "setSchemaDetailsAsesorReportMutation";
    Mutations["SET_RESULT_SUMMARIES_REPORT"] = "setResultSummariesReportMutation";
    Mutations["SET_RESULT_DETAIL_REPORT"] = "setResultDetailReportMutation";
    Mutations["SET_FILTERS"] = "setFiltersMutation";
    Mutations["CLEAR_FILTER"] = "clearFiltersMutation";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
